module.exports = __webpack_public_path__ + "public/img/1nCode.3ab01373.png";